/* eslint-disable complexity */
import * as React from 'react';
import { IconQuestionMark } from '@baidu/lsqm-icon';
import classNames from 'classnames';
import { Popover, Form } from '@osui/ui';
import { useFieldAlign } from '@baidu/icloud-ui-card';
import { prefixCls } from '../../utils';
import { useFieldContext } from './fieldContext';
import { FieldError } from './FieldError';
import './FieldUi.less'; // ant-form-item-has-error 需要引入form的样式。毕竟别的项目不一定引入了 antd form
// eslint-disable-next-line

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export const neveruse = Form;
export function FieldUi(props) {
  const {
    className,
    label,
    required,
    tooltip,
    tooltipPlacement,
    description,
    errorPosition,
    hideError,
    contentFull,
    emptyLabel,
    disableAlign,
    children
  } = props;
  const error = props.error;
  const warning = props.warning;
  const loading = props.loading;
  const hasLabel = label != null;
  const {
    preName
  } = useFieldContext();
  const {
    fieldRef,
    fieldStyle
  } = useFieldAlign({
    disableAlign: !hasLabel || disableAlign,
    domSelector: `.${prefixCls}-label`
  });
  let clonedChildren = children;

  if ( /*#__PURE__*/React.isValidElement(children)) {
    // 需要把错误信息透传给children
    const status = error ? 'error' : warning ? 'warning' : '';
    clonedChildren = /*#__PURE__*/React.cloneElement(children, {
      status
    });
  }

  return /*#__PURE__*/_jsxs("div", {
    className: classNames(className, `${prefixCls}-field`, {
      [`${prefixCls}-field-no-label`]: !hasLabel
    }),
    "data-name": preName,
    children: [hasLabel && /*#__PURE__*/_jsx("span", {
      ref: fieldRef,
      style: fieldStyle,
      className: `${prefixCls}-label`,
      children: /*#__PURE__*/_jsxs("span", {
        className: classNames(`${prefixCls}-label-text`, {
          [`${prefixCls}-required`]: required
        }),
        children: [label, ":"]
      })
    }), emptyLabel && /*#__PURE__*/_jsx("span", {
      className: `${prefixCls}-label`
    }), /*#__PURE__*/_jsxs("div", {
      className: `${prefixCls}-container`,
      children: [/*#__PURE__*/_jsxs("div", {
        className: classNames(`${prefixCls}-input-wrapper`, errorPosition === 'bottom' ? `${prefixCls}-input-wrapper-error-bottom` : ''),
        children: [/*#__PURE__*/_jsxs("div", {
          className: classNames(`${prefixCls}-item`, {
            [`${prefixCls}-input-full`]: contentFull
          }),
          children: [clonedChildren, !!tooltip && /*#__PURE__*/_jsx(Popover, {
            placement: tooltipPlacement,
            content: tooltip,
            children: /*#__PURE__*/_jsx(IconQuestionMark, {
              className: `${prefixCls}-tool-tip`
            })
          })]
        }), !loading && !hideError && /*#__PURE__*/_jsx(FieldError, {
          error: error
        })]
      }), !!description && /*#__PURE__*/_jsx("p", {
        className: `${prefixCls}-description`,
        children: description
      })]
    })]
  });
}
FieldUi.displayName = "FieldUi";
//# sourceMappingURL=es/Other/Field/FieldUi.js.map